import { energyAnalysisApiSlice } from "../apiSlice";

export const portfolioAnalysisApiSlice = energyAnalysisApiSlice.injectEndpoints({
    endpoints: builder => ({
        getPortfolioAnalysisPower: builder.query({
            query: ({ 
                recalc_account_id, 
            }) => {
                return {
                    url: `/portfolio_analysis_power/${recalc_account_id}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),
        getPortfolioAnalysisWater: builder.query({
            query: ({ 
                recalc_account_id, 
            }) => {
                return {
                    url: `/portfolio_analysis_water/${recalc_account_id}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),
        getPortfolioAnalysisHeat: builder.query({
            query: ({ 
                recalc_account_id, 
            }) => {
                return {
                    url: `/portfolio_analysis_heat/${recalc_account_id}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),
        getPortfolioAnalysisSubscription: builder.query({
            query: ({ 
                recalc_account_id, 
            }) => {
                return {
                    url: `/subscription/${recalc_account_id}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysisSubscription'],

        }),
        getPortfolioAnalysisSubscriptions: builder.query({
            query: () => {
                return {
                    url: `/subscriptions`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysisSubscription'],

        }),
        getMonthlyData: builder.query({
            query: ({ unit_id, unit_type_input_id, data_type }) => ({
                url: `/monthly_data`,
                method: 'GET',
                params: {
                    unit_id,
                    unit_type_input_id,
                    data_type,
                },
            }),
            providesTags: ['MonthlyData'],
        }),

        getBenchmarking: builder.query({
            query: ({ 
                recalc_account_id, 
            }) => {
                return {
                    url: `/benchmark/${recalc_account_id}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),

        getBenchmarkChartData: builder.query({
            query: ({ accountId, matrikelKey }) => ({
                url: `/detailed_benchmark/${accountId}/${matrikelKey}`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkChartData'],
        }),

        getBenchmarkOverwrite: builder.query({
            query: ({ account_id }) => ({
                url: `/benchmark_overwrite/${account_id}`,
                method: 'GET',
            }),
            providesTags: ['BenchmarkOverwrite'],
        }),

        deleteBenchmarkOverwrite: builder.mutation({
            query: ({ account_id, matrikel_key }) => ({
                url: `/benchmark_overwrite/${account_id}/${matrikel_key}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['BenchmarkOverwrite'],
        }),

        updateBenchmarkOverwrite: builder.mutation({
            query: ({ account_id, matrikel_key, body }) => ({
                url: `/benchmark_overwrite/${account_id}/${matrikel_key}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: ['BenchmarkOverwrite'],
        }),

        createBenchmarkOverwrite: builder.mutation({
            query: ({ account_id, body }) => ({
                url: `/benchmark_overwrite/${account_id}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['BenchmarkOverwrite'],
        }),

        getBuildingUseList: builder.query({
            query: () => ({
            url: `/building_use_list`,
            method: 'GET',
            }),
            providesTags: ['BuildingUseList'],
        }),

        getHeatInstallationList: builder.query({
            query: () => ({
            url: `/heat_installation_list`,
            method: 'GET',
            }),
            providesTags: ['HeatInstallationList'],
        }),
        postPortfolioUpdateNow: builder.mutation({
            query: ({ recalc_account_id}) => ({
                url: `/update_portfolio_analysis_now/${recalc_account_id}`,
                method: 'PUT',
            })
        }),
        setDaytimeInterval: builder.mutation({
            query: ({ account_id, metering_point_id, daytime_start, daytime_end }) => ({
                url: `/daytime_interval/${account_id}/${metering_point_id}`,
                method: 'PUT',
                params: daytime_start !== null && daytime_end !== null && {
                    daytime_start,
                    daytime_end,
                },
            }),
        }),
        setDaytimeIntervalUnit: builder.mutation({
            query: ({ account_id, unit_id, meter_type, daytime_start, daytime_end }) => ({
                url: `/daytime_interval_unit/${account_id}/${unit_id}`,
                method: 'PUT',
                params: daytime_start !== null && daytime_end !== null && meter_type !== null && {
                    meter_type,
                    daytime_start,
                    daytime_end,
                },
            }),
        }),
        getPortfolioHourAnalysis: builder.query({
            query: (args) => {
                const {
                    accountId,
                    meteringPointId,
                    start,
                    end,
                    activeDaysFilter,
                    activeHolidaysFilter
                } = args

                const params = new URLSearchParams({
                    start_timestamp: new Date(start).toISOString(),  // Ensure ISO format
                    end_timestamp: new Date(end).toISOString(),      // Ensure ISO format
                });

                if (activeDaysFilter !== undefined) {
                    params.append("active_days_filter", activeDaysFilter.toString());
                }
                if (activeHolidaysFilter !== undefined) {
                    params.append("holidays_filter", activeHolidaysFilter.toString());
                }

                return {
                    url: `/hour_analysis_portfolio/${accountId}/${meteringPointId}?${params.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),
        getPortfolioDurationAnalysis: builder.query({
            query: (args) => {
                const {
                    accountId,
                    meteringPointId,
                    start,
                    end,
                    activeHoursFilter,  // Optional boolean
                    activeDaysFilter,    // Optional boolean
                    activeHolidaysFilter // Optional boolean
                } = args

                const params = new URLSearchParams({
                    start_timestamp: new Date(start).toISOString(),  // Ensure ISO format
                    end_timestamp: new Date(end).toISOString(),      // Ensure ISO format
                });

                  // Conditionally append parameters only if they are explicitly set (true or false)
                  if (activeHoursFilter !== undefined) {
                    params.append("active_hours_filter", activeHoursFilter.toString());
                }
                if (activeDaysFilter !== undefined) {
                    params.append("active_days_filter", activeDaysFilter.toString());
                }
                if (activeHolidaysFilter !== undefined) {
                    params.append("holidays_filter", activeHolidaysFilter.toString());
                }

                return {
                    url: `/duration_analysis_portfolio/${accountId}/${meteringPointId}?${params.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['PortfolioAnalysis'],
        }),
    }),
});

export const {
    useGetPortfolioAnalysisPowerQuery,
    useGetPortfolioAnalysisWaterQuery,
    useGetPortfolioAnalysisHeatQuery,
    useGetPortfolioAnalysisSubscriptionQuery,
    useGetPortfolioAnalysisSubscriptionsQuery,
    useGetMonthlyDataQuery,
    useGetBenchmarkingQuery,
    useGetBenchmarkChartDataQuery,
    useGetBenchmarkOverwriteQuery,
    useDeleteBenchmarkOverwriteMutation,
    useUpdateBenchmarkOverwriteMutation,
    useCreateBenchmarkOverwriteMutation,
    useGetBuildingUseListQuery,
    useGetHeatInstallationListQuery,
    usePostPortfolioUpdateNowMutation,
    useSetDaytimeIntervalMutation,
    useSetDaytimeIntervalUnitMutation,
    useGetPortfolioHourAnalysisQuery,
    useGetPortfolioDurationAnalysisQuery,
} = portfolioAnalysisApiSlice;